import { render, staticRenderFns } from "./AssessmentTypeSelect.vue?vue&type=template&id=2ec4b3c5&"
import script from "./AssessmentTypeSelect.vue?vue&type=script&lang=js&"
export * from "./AssessmentTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentTypeSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports